import React, { useContext } from 'react';
import Toast from 'react-bootstrap/Toast';
import { DataContext } from '../../../stores/crm-store';

const Toasts = () => {
    const {
        store: { isSavedToastOpen, isDeletedToastOpen, isErrorToastOpen },
        dispatch,
    } = useContext(DataContext);

    const onToastClose = (type) => {
        dispatch({ type });
    };

    return (
        <div className='toasts'>
            <CustomToast
                className='bg-success'
                icon='oi-check'
                content='Sparad'
                isOpen={isSavedToastOpen}
                onClose={() => onToastClose('CLOSE_SAVED_TOAST')}
            />
            <CustomToast
                className='bg-danger'
                icon='oi-x'
                content='Raderad'
                isOpen={isDeletedToastOpen}
                onClose={() => onToastClose('CLOSE_DELETED_TOAST')}
            />
            <CustomToast
                className='bg-danger'
                icon='oi-x'
                content='Error'
                isOpen={isErrorToastOpen}
                onClose={() => onToastClose('CLOSE_ERROR_TOAST')}
            />
        </div>
    );
};

export default Toasts;

const CustomToast = ({ className, icon, content, isOpen, onClose, delay }) => {
    if (delay == null) {
        delay = 2 * 1000;
    }
    return (
        <Toast className={className} onClose={onClose} show={isOpen} delay={delay} autohide animation>
            <Toast.Body>
                <div className={'oi ' + icon} />
                <div>{content}</div>
            </Toast.Body>
        </Toast>
    );
};
